// Charge la base commune
import './common.js'

// Pajination
async function getPajination () {
  import(/* webpackChunkName: "pajination", webpackPrefetch: true */ './js/components/pajination.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    // sur changement de page, on se repositionne sur le début de listing
    $('ul.pagination > li > a').off().on('click', function () {
      const h = $('#header').height()
      const p = $(this).parents('.pajinate-nav').height()
      $('html').animate({ scrollTop: $('#step-pagination').offset().top - h - p - 10 }, { duration: 300, easing: 'linear' })
    })
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion des pages
  $('.pajinate').waypoint(function () {
    getPajination()
    this.destroy()
  }, {
    offset: '100%'
  })

  $('.alert').waypoint(function () {
    import(/* webpackChunkName: "alertBs" */ './scss/components/alertBs.scss').then(() => {
      Waypoint.refreshAll()
    })
    this.destroy()
  }, {
    offset: '100%'
  })

  // css complémentaires à un article en détail
  $('.text-content').waypoint(function () {
    import(/* webpackChunkName: "textContent", webpackPrefetch: true */ './scss/components/textContent.scss')
    this.destroy()
  }, {
    offset: '100%'
  })

  if ($('.go').length) {
    const target = $('.go')
    $('html').animate({ scrollTop: ($(target).offset().top - $('#header').height()) - 20 }, { duration: 300, easing: 'linear' }, function () {
      $('html').animate({ scrollTop: ($(target).offset().top - $('#header').height()) - 20 }, { duration: 300, easing: 'linear' })
    })
  }
})
